export default __webpack_public_path__ + "static/media/alarm.13e6dab0.png";